
	import { defineComponent } from "vue";

	export default defineComponent({
		props: {
			color: String,
			width: String,
		},
	});
